export const FOCUSABLE_ELEMENTS_SELECTORS = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
